import { render, staticRenderFns } from "./CountryMapSection.vue?vue&type=template&id=bcba7cbc&scoped=true"
import script from "./CountryMapSection.vue?vue&type=script&lang=js"
export * from "./CountryMapSection.vue?vue&type=script&lang=js"
import style0 from "./CountryMapSection.vue?vue&type=style&index=0&id=bcba7cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcba7cbc",
  null
  
)

export default component.exports